/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=    require('react-dnd'),DragDropMixin=$__1.DragDropMixin;

var Card = React.createClass({displayName: 'Card',
  mixins: [DragDropMixin],

  propTypes: {
    id: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired,
    moveCard: PropTypes.func.isRequired
  },

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.CARD, {
      dragSource: {
        beginDrag:function() {
          return {
            item: {
              id: this.props.id
            }
          };
        }
      },

      dropTarget: {
        over:function(item) {
          this.props.moveCard(item.id, this.props.id);
        }
      }
    });
  },

  render:function() {
    var $__0=    this.getDragState(ItemTypes.CARD),isDragging=$__0.isDragging;

    return (
      React.createElement("div", React.__spread({},  this.dragSourceFor(ItemTypes.CARD), 
           this.dropTargetFor(ItemTypes.CARD), 
           {style: {
             border: '1px dashed gray',
             backgroundColor: 'white',
             padding: '0.5rem',
             margin: '0.5rem',
             opacity: isDragging ? 0 : 1
           }}), 
        this.props.text
      )
    );
  }
});

module.exports = Card;


/*****************
 ** WEBPACK FOOTER
 ** ./_sortable-simple/Card.js
 ** module id = 147
 ** module chunks = 0
 **/